// This file contains all the routines that specifically relate to the add whitespace into display feature

// constants, class definitions, and createjs library
import * as createjs from "createjs-module";

import { STATE_NORMAL, STATE_IN_WHITESPACE_ADD} from 'src/assets/js/cv-classes.js';
import {WhiteSpaceSelector,ONE_PAGE_LENGTH,WhiteSpaceSize,undoStackType, 
        UNDO_TYPE_WHITESPACE,CURSOR_COLOR} from 'src/app/shared/constant/drawConstants';

// functions and variables
import {db,stage,cvControl,clearProbState, cvGetDataUndoPush} from 'src/assets/js/draw.js';
import { setStageBackground,handleStageMouse } from 'src/assets/js/cv-graphics-mouse.js';
import { pushUndoObj, penItemFindStartY } from 'src/assets/js/cv-helpers.js';
import { cvHandleGetFileData } from 'src/assets/js/cv-file.js';


// selectWhiteSpace is called by cvControl in draw.js as the top level routine
export function selectWhiteSpace() {

    // if there are any db states (clipboard) then clear them first
    if (db.state != STATE_NORMAL) {
      clearProbState(true,true);
    }
    db.state = STATE_IN_WHITESPACE_ADD;
    let splitLoc = new (WhiteSpaceSelector);
  
   
    let bitmapToSplit = db.bitmap;
  
    drawSelectWhiteSpace();
    
  
  }
    
  // addWhiteSpace is called from the event handlers within drawSelectWhiteSpace
  // it is the top level routine to manage splitting images, moving math problems, 
  // saving to file and managing undo

  export function addWhiteSpace(splitLoc, undoObj, imgIndex) {

    let nextImgIndex; 
    let noSplit = false;
    db.fileChanged = true;
    // manage spliting images, if there is a background image. 
    if (db.bitmap.length > 0)  {
   
      // figure out which image this may be in if not from redo - due to prior splits images may not be aligned on pages
      if (undoObj == null) {
        imgIndex = 0;
        
        for (let i = 0; i < db.bitmap.length && splitLoc.startY > db.bitmap[i].y ; i++) {
          imgIndex = i;
        }
      } 
     
      let lastSourceRectY = 0;
      let lastSourceRectHeight = db.bitmap[imgIndex].image.height;
      
      // save last SourceRec before it is updated, for undo
      if (db.imageSourceFromSplits != null ) { 
        lastSourceRectY = db.imageSourceFromSplits[imgIndex].startY;
        lastSourceRectHeight = db.imageSourceFromSplits[imgIndex].height;
      }
    
      // determine if user selection is over image or in previously added whitespace
      let imageStart = db.imageSourceFromSplits[imgIndex].startY;
      let imageHeight = db.imageSourceFromSplits[imgIndex].height;
      let localStartY = splitLoc.startY - db.bitmap[imgIndex].y;
      if (localStartY < imageHeight) {
        let imgObj = db.bitmap[imgIndex];
        splitOneImage(imgObj, splitLoc, imgIndex);
        nextImgIndex = imgIndex+2;  // split pushed 2 images to image array
      }
      else {
        adjustCanvasSizeAfterWhiteSpace(splitLoc);
        nextImgIndex = imgIndex+1;
        noSplit = true;
      }
    
      // update the positions of any images beyond the split
      let spaceSize = splitLoc.endY - splitLoc.startY;
      for (let i = nextImgIndex; i < db.bitmap.length; i++) {
        db.bitmap[i].y += spaceSize;
        db.imageSourceFromSplits[i].imageY = db.bitmap[i].y;
      }
      

      // update coordinates of the math problems after the split
      moveMathProbsAfterSplit(splitLoc);
      movePenItemsAfterSplit(splitLoc);

      // push an entry unto the undo stack for this change
      db.fileChanged = true;

      undoPushWhiteSpace(imgIndex, db.imageSourceFromSplits[imgIndex].originalImgIndex,
                          lastSourceRectY, lastSourceRectHeight, splitLoc, noSplit);
    }
    // if no image, then just move problems and do regular undo push
    else {
      if (db.mProb.length > 0) {
        moveMathProbsAfterSplit(splitLoc);
        movePenItemsAfterSplit(splitLoc);
        db.fileChanged = true;
        cvGetDataUndoPush();
      }

    }

    db.state = STATE_NORMAL;
    stage.update();
  
  }

  
  // for whitespace undos, only push special information to the undo stack, not all the math problems
  export function undoPushWhiteSpace(imgIndex, origImgIndex, rectY, rectHeight, splitLoc, noSplit) {

    let undoObj = new undoStackType();
    db.mathFile = cvHandleGetFileData(undoObj); 
 
    // add special fields for recording whitespace position
    undoObj.type = UNDO_TYPE_WHITESPACE;
    undoObj.whiteSpaceIndex = imgIndex;
    if (noSplit) {
      undoObj.noSplit = true;
    }
  
    undoObj.priorWhiteSpaceSize = new WhiteSpaceSize(rectY, rectHeight, origImgIndex, imgIndex, db.bitmap[imgIndex].y );
    undoObj.priorWhiteSpaceSize.addedStartY = splitLoc.startY;
    undoObj.priorWhiteSpaceSize.addedEndY = splitLoc.endY;
  
    if (db.curProb != null) {
      pushUndoObj(db.mathFile,undoObj);
    }
    else {
      db.undoStack.push(undoObj);
    }
    db.fileChanged = true;
}

// clear out and cancel the user UI if user presses undo while selecting the add whitespace area
export function cancelWhiteSpaceAdd() {

  stage.enableMouseOver(0);
  let coverRect= stage.getChildByName("whitespace background");
  coverRect.removeAllEventListeners();
  stage.removeChild(coverRect);
  let selectCont = stage.getChildByName("whitespace container");
  stage.removeChild(selectCont);
  let msgButton= stage.getChildByName("whitespace button");
  stage.removeChild(msgButton);
  db.state = STATE_NORMAL;

  let canvas = document.getElementById('drawingboard');
  canvas.classList.remove("crosshair-cursor");
  canvas.classList.add("default-cursor");
  stage.update();

}
  
  // This routine manages the user UI of selecting an the size and location of whitespace to add
  // The user has a choice of doing a drag operation or two clicks to select an area
  function drawSelectWhiteSpace() {
  
  // draw temporary rectangle over whole canvas to indicate selection mode and
  // capture mouse clicks without disruption to anything else on the page
  // This rectangle will be removed at the end
      let coverRect = new createjs.Shape();
      coverRect.graphics.beginFill("grey");
      coverRect.graphics.rect(0,0,stage.canvas.width/stage.scaleX,stage.canvas.height/stage.scaleX);     
      coverRect.x = 0;
      coverRect.y = 0;
      coverRect.name = "whitespace background";
      coverRect.alpha = .1;
      stage.enableMouseOver(10);
      let canvas = document.getElementById('drawingboard');
      canvas.classList.remove("default-cursor");
      canvas.classList.add("crosshair-cursor");
      //stage.cursor = 'crosshair'; 
      
      stage.addChild(coverRect);
      stage.update();
      let startY, endY, selectHeight, firstClickY;
      let needSecondClick = false;
      let selectBox = new createjs.Shape();
      let gotDrag = false;
      let done = false;
      let selectContainer = new createjs.Container();
      selectContainer.name = "whitespace container";
      stage.addChild(selectContainer);
      //stage.enableMouseOver(10);
  
      // watch for first mouse down
      coverRect.addEventListener("mousedown", function (e) {
  
        // first check for case that this is second click, after a selection has been done
        // using stagemouse move, if so then finish selection and call addwhitespace
      
        if (needSecondClick) {
          
          coverRect.removeAllEventListeners();
          stage.removeAllEventListeners("stagemousemove");
          stage.enableMouseOver(0);
          canvas.classList.remove("crosshair-cursor");
          canvas.classList.add("default-cursor");
          endY = stage.mouseY/stage.scaleX;
          done = true;
          //coverRect.cursor = 'auto'; 
          stage.update();
        
          finishWhiteSpaceSelect(firstClickY, endY, selectContainer, coverRect,selectBox);
  
        }
        // this is the first setup for a click, so setup createjs objects to display selection boxes to user
        else {
       
          startY = stage.mouseY/stage.scaleY;
          selectHeight = 10;
          selectBox.graphics.beginStroke("darkgrey").setStrokeStyle(3).beginFill("white");
          selectBox.graphics.rect(0,0,stage.canvas.width/stage.scaleX,selectHeight); 
          selectBox.x = 0;
          selectBox.y = startY; 
          selectContainer.addChild(selectBox);
          stage.update();
          
          // in order to give the user a choice of dragging or two clicks, use stagemousemove 
          // since this is only available on the stage have to enable it and call on stage
          //stage.enableMouseOver(10);
          stage.addEventListener('stagemousemove',function (e) {
       
            selectBox.graphics.clear();
            endY = stage.mouseY/stage.scaleX;
            selectHeight = endY - startY;
            selectBox.graphics.beginStroke("darkgrey").setStrokeStyle(3).beginFill("white");
            selectBox.graphics.rect(0,0,stage.canvas.width/stage.scaleX,selectHeight);
            gotDrag = true;
            stage.update();
          });
        
          //stage.addEventListener('stagemouseup',function(e) {
          coverRect.addEventListener('pressup',function(e) {
            
            if (gotDrag || needSecondClick) {
              coverRect.removeAllEventListeners();
              stage.removeAllEventListeners("stagemousemove");
              stage.enableMouseOver(0);
              done = true;
            }
            else {  // continue to allow user to select box with clicks
              coverRect.removeAllEventListeners('pressup');
              needSecondClick = true;
              firstClickY = startY;
            }
  
            if (done) {
              canvas.classList.remove("crosshair-cursor");
              canvas.classList.add("default-cursor");
              stage.update();
              finishWhiteSpaceSelect(startY, endY, selectContainer, coverRect, selectBox);
            } 
            
          });
        }
      
      });
  }
  
  // called when event handlers are done in above routine to initiate the rest of the whitespace add
  function finishWhiteSpaceSelect(startY, endY, selectContainer, coverRect, selectBox) {
    // check if dragged upwords, and swap values if so
    if (endY < startY )  {
      let temp = startY;
      startY = endY;
      endY = temp;
      
    }
    let dragBoxSize = 30;
    let topBoxStart = startY - dragBoxSize;
    let botBoxStart = endY;

    let whiteSpaceLoc = new WhiteSpaceSelector(startY, endY);
    whiteSpaceLoc.startY = startY
    whiteSpaceLoc.endY = endY;
   
    // draw two drag boxes to allow the user to adjust the whitespace size up and down
    whiteSpaceDragBox(selectContainer, selectBox, whiteSpaceLoc, topBoxStart, true );
    
    whiteSpaceDragBox(selectContainer, selectBox, whiteSpaceLoc, botBoxStart, false );
    

    // draw an OK and Cancel  button for the user to click on when done with whitespace add
    let msgButton = new createjs.Container();
    msgButton.name = "whitespace button";
    let msgShape = new createjs.Shape();
    let cancelShape = new createjs.Shape();
    let frameButtons = new createjs.Shape();
    let OKMsg = new createjs.Text("OK","Bold 16px Arial", "black"); 
    let userMsg = new createjs.Text("Cancel","Bold 16px Arial", "black"); 
                            
    userMsg.y = OKMsg.y = 22;
    msgShape.y = 10;
    userMsg.x = 200;
    OKMsg.x = 45;
    
    msgShape.graphics.setStrokeStyle(2).beginStroke("black").beginFill(CURSOR_COLOR).drawRoundRect(0,0,120,36,18);     
    msgButton.x = 120;
    msgButton.y = startY;
    cancelShape.graphics.setStrokeStyle(2).beginStroke("black").beginFill("bisque").drawRoundRect(0,0,120,36,18);  
    cancelShape.x = 170;  
    cancelShape.y = 10; 
    frameButtons.graphics.beginFill("white").rect(0,0,300,44);  
    frameButtons.x = -4;  
    frameButtons.y = 7; 
    msgButton.x = 120;
    msgButton.y = startY;
    msgButton.addChild(frameButtons);
    msgButton.addChild(cancelShape);
    msgButton.addChild(msgShape);
    msgButton.addChild(userMsg);
    msgButton.addChild(OKMsg);
    
    stage.addChild(msgButton);
    stage.update();

    // when the user clicks OK, then remove the createjs objects for selection, and continue 
    // with the white space add
    msgShape.addEventListener("click", function (e) {
      stage.removeChild(msgButton);
      stage.removeChild(selectContainer);
      stage.removeChild(coverRect);
      addWhiteSpace(whiteSpaceLoc);
      stage.update();

    });

    // if the user instead clicks the cancel, then just remove the createjs objects for selection and do nothing else
    cancelShape.addEventListener("click", function (e) {
      cancelWhiteSpaceAdd();
    });

  }
  
// Draw a single drag rectangle for selection area, with isTopOne true if for top box, false if for bottom box
function whiteSpaceDragBox(selectContainer, selectBox, selectObj, startBoxY, isTopOne )  {

  let dragBoxSize = 30;
  let dragBoxWidth = 80;
  let dragPlusX = dragBoxWidth/2 - 5;
  let dragPlusY = dragBoxSize/2 - 5;
  let newY, selectHeight;

  // Allow dragging of top or bottom of box
  let dragBox = new createjs.Shape();
  dragBox.cursor = 'ns-resize'; 
  dragBox.graphics.beginStroke("darkgrey").setStrokeStyle(3).beginFill("white");
  dragBox.graphics.rect(0,0,dragBoxWidth,dragBoxSize);  
  dragBox.graphics.beginStroke("green").setStrokeStyle(2).moveTo(dragBoxWidth/2,dragPlusY).lineTo(dragBoxWidth/2,dragPlusY+10)
  dragBox.graphics.moveTo(dragPlusX,dragBoxSize/2).lineTo(dragPlusX+10,dragBoxSize/2);  
  dragBox.x = stage.canvas.width/2-dragBoxWidth/2;
  dragBox.y = startBoxY;
  selectContainer.addChild(dragBox);
  stage.update();
  dragBox.addEventListener("mousedown", function (e) {

    dragBox.addEventListener('pressmove',function (e) {
      newY = stage.mouseY/stage.scaleX; 
     
      // only allow user to move drag boxes, but not reverse them (top below bottom, and vice versa)
      if ((isTopOne && (newY < selectObj.endY-20)) ||
          (!isTopOne && (newY > selectObj.startY+20))) {
        selectBox.graphics.clear();
        if (isTopOne) {
          selectObj.startY = stage.mouseY/stage.scaleX;  
          dragBox.y = selectObj.startY - dragBoxSize; 
        }
        else {
          selectObj.endY = stage.mouseY/stage.scaleX; 
          dragBox.y = selectObj.endY; 
        } 
        selectHeight = selectObj.endY - selectObj.startY;
        selectBox.y = selectObj.startY;
        selectBox.graphics.beginStroke("darkgrey").setStrokeStyle(3).beginFill("white");
        selectBox.graphics.rect(0,0,stage.canvas.width/stage.scaleX,selectHeight);
        stage.update();
      }
    });
    dragBox.addEventListener('pressup',function(e) {
    });
  });
   
}
  
  /**
   * 
   * function splitOneImage is used when the user adds whitespace lines into canvas.
   * It splits the background imported image that the user clicks into two parts, and adds
   * in empty space based on size of user selection, and adjust later image coordiantes and 
   * saves source rect positions needed for any later image splits
   * imgIndex is the index within the bitmaps array - any prior whitespace split will have adjusted this
   * splitloc shows where the user created a selection rectangle
   */
  
  function splitOneImage(imgObj, splitLoc,imgIndex) {
 
    db.hasSplits = true;
    // Create two new Bitmap objects for the top and bottom parts by cloning to retain prior properties
    var topPart = imgObj.clone();
    var bottomPart = imgObj.clone();   
   
    // adjust the cursor click to the current image position
    let localStartY = splitLoc.startY - imgObj.y;
    
    // Set the source rectangles for the two parts
    // Set top image source Rect to use the same starting y as the image it was cloned from -  stored in db.imageSourceFromSplits
    // The top image source Rect uses a height equal to the user selection relative to the start of the clicked upon image
    topPart.sourceRect = new createjs.Rectangle(0, db.imageSourceFromSplits[imgIndex].startY, imgObj.image.width, localStartY); 
   
    // Save source rect startY and height for later splits in parallel array, since this isn't easily retrieved from createjs
    let topNewLoc = new WhiteSpaceSize(db.imageSourceFromSplits[imgIndex].startY,localStartY,
                                       db.imageSourceFromSplits[imgIndex].originalImgIndex,imgIndex);
    topNewLoc.addedStartY = splitLoc.startY;
    topNewLoc.addedEndY = splitLoc.endY;
  
    // Set bottom image source rect start y to be equal to the prior image source rect + user click starting Y relative to image
    // Set bottom image source rect height to prior image source rect height - the height of the top half of image
   
    let botStartY = db.imageSourceFromSplits[imgIndex].startY+localStartY;
    let bottomPartHeight = db.imageSourceFromSplits[imgIndex].height - localStartY; 
    bottomPart.sourceRect = new createjs.Rectangle(0, botStartY, imgObj.image.width, bottomPartHeight);
    let botNewLoc = new WhiteSpaceSize(botStartY,bottomPartHeight, db.imageSourceFromSplits[imgIndex].originalImgIndex, imgIndex+1);
    botNewLoc.addedStartY = splitLoc.startY;
    botNewLoc.addedEndY = splitLoc.endY;
   
       // Set the positions of the two parts
    topPart.x = bottomPart.x = imgObj.x; // Preserve the X-coordinate of the original bitmap
    topPart.y = topNewLoc.imageY = imgObj.y;
    bottomPart.y = botNewLoc.imageY = splitLoc.endY;  // position of bottom half image goes at the end of the area user selected 

    // remove the prior image and add in the two halfs, and do the same for the obj to track splits positions
    db.bitmap.splice(imgIndex,1,topPart, bottomPart); 
    db.imageSourceFromSplits.splice(imgIndex,1,topNewLoc, botNewLoc);

    for (let i = imgIndex+2; i < db.imageSourceFromSplits.length; i++) {
         db.imageSourceFromSplits[i].priorImgIndex++;
    }

    // add the amount of space added to lastCanvasY to be able to track the length of the image, to help with canvas sizing
    
    adjustCanvasSizeAfterWhiteSpace(splitLoc);
    
    // remove prior image object and Add the two parts to the stage
    db.fileImage.removeChild(imgObj);
    db.fileImage.addChild(topPart, bottomPart);

    stage.update();
    }


  // undo a prior white space add of the image split and image moves 
  export function undoWhiteSpaceAdd(undoObj) {
    
    let imgIndex = undoObj.whiteSpaceIndex;
    let spaceToRemove;
    db.fileChanged = true;
    
    let priorWhiteSpaceAddSize = db.imageSourceFromSplits[imgIndex+1].addedSize;
    let priorSize = undoObj.priorWhiteSpaceSize;
    
    if (!undoObj.noSplit) {
      // replace the indexed image in the undo record plus the one after it, with a clone of the undo 
      // record image with the sourceRect set to its prior size
      
      //let imgIndex = priorSize.priorImgIndex;
        let unsplitImg = db.bitmap[imgIndex].clone();
      unsplitImg.sourceRect = new createjs.Rectangle(0, priorSize.startY, stage.canvas.width, priorSize.height); 
      unsplitImg.y = priorSize.imageY;
      spaceToRemove = db.bitmap[imgIndex+1].y - (db.bitmap[imgIndex].y+db.imageSourceFromSplits[imgIndex].height);
    
      priorSize.priorImgIndex = imgIndex; 
      db.imageSourceFromSplits.splice(imgIndex,2,priorSize);
       
      db.fileImage.removeChild(db.bitmap[imgIndex], db.bitmap[imgIndex+1]); 
      db.fileImage.addChild(unsplitImg); 
      db.bitmap.splice(imgIndex,2,unsplitImg); 

    }
    else {
      spaceToRemove = undoObj.priorWhiteSpaceSize.addedEndY - undoObj.priorWhiteSpaceSize.addedStartY;
    }

    
    // update the positions of any images beyond the split
    for (let i = imgIndex+1; i < db.bitmap.length; i++) {
 
      db.bitmap[i].y -= spaceToRemove;
      db.imageSourceFromSplits[i].imageY = db.bitmap[i].y;
    }
    let splitLoc = new WhiteSpaceSelector;
    splitLoc.startY = priorSize.addedStartY;
    splitLoc.endY = priorSize.addedEndY;
    
    moveMathProbsAfterUndoSplit(splitLoc);
    movePenItemsAfterUndoSplit(splitLoc);
    
    adjustCanvasSizeAfterUndoWhiteSpace(spaceToRemove);
    stage.update();
   
  }
    
   // redo a prior white space add of the image split and image moves 
   export function redoWhiteSpaceAdd(undoObj) {
 
    let imgIndex = undoObj.priorWhiteSpaceSize.priorImgIndex;

    let splitLoc = new WhiteSpaceSelector();
    splitLoc.startY = undoObj.priorWhiteSpaceSize.addedStartY; 
    splitLoc.endY = undoObj.priorWhiteSpaceSize.addedEndY;

    addWhiteSpace(splitLoc, undoObj, imgIndex);
    
  }

  
  // called from routines in cv-file.js to adjust the images if a file is opened that had prior whitespace splits
  export function updateSavedImagesForPriorSplits(splits) {

    let nextImg;  
    let splitBitMaps = [];

    for (let i = 0; i < splits.length; i++) {
     
      nextImg = db.bitmap[splits[i].originalImgIndex].clone();
      nextImg.sourceRect = new createjs.Rectangle(0, splits[i].startY, stage.canvas.width, splits[i].height); 
      splitBitMaps.push(nextImg);
    }
   
    db.bitmap = [];
    for (let i = 0; i < splits.length; i++) {
      splitBitMaps[i].y = splits[i].imageY;
      db.bitmap.push(splitBitMaps[i]);
      db.fileImage.addChild(db.bitmap[i]);  
     
    }
    stage.update();

  }
    
    // Step through the math problems, and adjust problem coordinates for math
    // problems with start y positions after the image split
    function moveMathProbsAfterSplit(splitLoc) {
  
      let addedSpaceSize = splitLoc.endY - splitLoc.startY;
  
      for (let i=0; i < db.mProb.length; i++)  {
       
        if (db.mProb[i].container.y > splitLoc.startY) {
          db.mProb[i].container.y += addedSpaceSize;
          db.mProb[i].ypos += addedSpaceSize;
          // move math cursor only if current problem is moved
          if (db.pIndex == i) {
            db.ypos += addedSpaceSize;
          }
        }
      }

      stage.update();
  
    }


// Step through the pen times, and adjust those with locations 
    // past with start y positions after the image split
    // note pen item locations are involved and pasted on item type
function movePenItemsAfterSplit(splitLoc) {
  
    let addedSpaceSize = splitLoc.endY - splitLoc.startY;
    let penItem;

    for (let i=0; i < db.penItemList.length; i++)  {

      penItem = db.penItemList[i];
      if (!penItem.deleted) {
        if (penItemFindStartY(penItem) > splitLoc.startY) {
          penItem.container.y += addedSpaceSize;
        }
      }
    }

    stage.update();
  }

// Step through the math problems, and adjust problem coordinates for math
    // problems with start y positions after the image split
    function movePenItemsAfterUndoSplit(splitLoc) {
  
      let addedSpaceSize = splitLoc.endY - splitLoc.startY;
      let penItem;

      for (let i=0; i < db.penItemList.length; i++)  {

        penItem = db.penItemList[i];
        if (!penItem.deleted) {
          if (penItemFindStartY(penItem) - addedSpaceSize > splitLoc.startY) {
            penItem.container.y -= addedSpaceSize;
          }
        }
      }

      stage.update();
  
    }


    // Step through the math problems, and adjust problem coordinates for math
    // problems with start y positions after the image split
    function moveMathProbsAfterUndoSplit(splitLoc) {
  
      let addedSpaceSize = splitLoc.endY - splitLoc.startY;
      for (let i=0; i < db.mProb.length; i++)  {
       
        if (db.mProb[i].container.y - addedSpaceSize > splitLoc.startY) {
          db.mProb[i].container.y -= addedSpaceSize;
          db.mProb[i].ypos -= addedSpaceSize; 
          if (db.pIndex == i) {
            db.ypos -= addedSpaceSize;
          }
        }
      }

      stage.update();
  
    }
  
    // since whitespace splits are not full pages, the size of the canvas has to be evaluated to determine
    // when to add another page.  
    function adjustCanvasSizeAfterWhiteSpace(splitLoc) {

      // calculuate how much space is left on current page that hasn't been used
      let lastPageRem = db.lastCanvasY % ONE_PAGE_LENGTH;
      let spaceAvail = (lastPageRem == 0) ? 0 : ONE_PAGE_LENGTH - lastPageRem;
      let spaceAdded = splitLoc.endY - splitLoc.startY;
  
      if (spaceAdded > spaceAvail) {
        db.pageCount++;
        stage.canvas.height = (ONE_PAGE_LENGTH * db.pageCount) * stage.scaleX;

        // reset the stage background and stage mouse handler, since changed canvas size
        // add figuring out if page actually needed
        setStageBackground();
        handleStageMouse();
      }
      
      db.lastCanvasY += splitLoc.endY - splitLoc.startY;
     
    }

     // since whitespace splits are not full pages, the size of the canvas has to be evaluated to determine
    // when to add another page.  
    function adjustCanvasSizeAfterUndoWhiteSpace(spaceSize) {

      // calculuate how much space is left on current page that hasn't been used
      let lastPageRem = db.lastCanvasY % ONE_PAGE_LENGTH;
      //let spaceAvail = (lastPageRem == 0) ? 0 : ONE_PAGE_LENGTH - lastPageRem;
  
      if (spaceSize >= lastPageRem) {
        db.pageCount--;
        stage.canvas.height = (ONE_PAGE_LENGTH * db.pageCount) * stage.scaleX;

        // reset the stage background and stage mouse handler, since changed canvas size
        // add figuring out if page actually needed
        setStageBackground();
        handleStageMouse();
      }
    
      db.lastCanvasY -= spaceSize;
     
    }
    